module.exports = __webpack_public_path__ + "img/DSC_9279.7fbf9519.jpg";